import React, { useState } from "react";
import axios from "axios";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";

const LIMITE_IA = 3;

function ModalUsarIA({ idServicio, usoIA = 0, onSuccess }) {

    const [show, setShow] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [descripcionLibre, setDescripcionLibre] = useState("");

    const limitAlcanzado = usoIA >= LIMITE_IA;

    async function handleGenerar() {
        if (!descripcionLibre.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Cuéntanos tu servicio",
                text: "Escribe al menos una descripción breve para que la IA pueda ayudarte.",
                confirmButtonText: "Ok",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
            });
            return;
        }

        try {
            setCargando(true);
            const res = await axios.post("/ai-sugerir-texto", { descripcion: descripcionLibre, idServicio });

            if (res.data.ok) {
                setShow(false);
                setDescripcionLibre("");
                if (onSuccess) onSuccess(res.data.resultado);
                else window.location.reload();
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: res.data.mensaje || "No pudimos generar el contenido. Intenta de nuevo.",
                    confirmButtonText: "Ok",
                    customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
                });
            }
        }
        catch (err) {
            console.error("Error al generar con IA:", err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Por el momento no podemos usar la IA, intenta más tarde.",
                confirmButtonText: "Ok",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
            });
        }
        finally {
            setCargando(false);
        }
    }

    return (
        <div>
            {limitAlcanzado ? (
                <button className="btn btn-outline-secondary" disabled>
                    <i className="bi bi-stars me-2"></i>
                    Máximo de intentos alcanzado ({LIMITE_IA}/{LIMITE_IA})
                </button>
            ) : (
                <Button variant="outline-primary" onClick={() => setShow(true)}>
                    <i className="bi bi-stars me-2"></i>
                    Crear con IA
                    <span className="ms-2 badge bg-primary">{usoIA}/{LIMITE_IA}</span>
                </Button>
            )}

            <Modal show={show} onHide={() => setShow(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="bi bi-stars me-2" style={{ color: "var(--naranja-cta)" }}></i>
                        Crear contenido con IA
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="px-4 py-4">
                    <p className="text-muted mb-1">
                        Cuéntanos con tus propias palabras de qué trata tu servicio y la IA se encargará de crear:
                    </p>
                    <ul className="text-muted small mb-3">
                        <li>Título atractivo</li>
                        <li>Descripción profesional</li>
                        <li>Paquete básico con detalles</li>
                        <li>Pregunta frecuente</li>
                    </ul>

                    <div className="alert alert-warning py-2 small mb-3">
                        <i className="bi bi-exclamation-triangle me-2"></i>
                        Tienes <b>{LIMITE_IA - usoIA} intento{LIMITE_IA - usoIA !== 1 ? "s" : ""} restante{LIMITE_IA - usoIA !== 1 ? "s" : ""}</b> para este servicio.
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">¿De qué trata tu servicio?</label>
                        <textarea
                            className="form-control"
                            rows={5}
                            placeholder='Ej: "Soy fotógrafo profesional con 5 años de experiencia. Hago fotos de bodas, quinceañeras y eventos corporativos en Bogotá. Entrego las fotos editadas en alta calidad en máximo 7 días..."'
                            value={descripcionLibre}
                            onChange={(e) => setDescripcionLibre(e.target.value)}
                            maxLength={800}
                            disabled={cargando}
                        />
                        <div className="text-end text-muted small mt-1">
                            {descripcionLibre.length}/800
                        </div>
                    </div>

                    {cargando && (
                        <div className="text-center py-3">
                            <div className="spinner-border text-primary mb-2" />
                            <p className="text-muted small mb-0">Generando contenido, un momento...</p>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="d-flex flex-column gap-2 px-4">
                    <Button
                        variant="primary"
                        className="w-100"
                        onClick={handleGenerar}
                        disabled={cargando || !descripcionLibre.trim()}
                    >
                        {cargando
                            ? <><span className="spinner-border spinner-border-sm me-2" />Generando...</>
                            : <><i className="bi bi-stars me-2" />Generar con IA</>
                        }
                    </Button>
                    <Button variant="secondary" className="w-100" onClick={() => setShow(false)} disabled={cargando}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ModalUsarIA;
